/*
 * @Copyright: @ Silk Software Corp. All Rights Reserved Based on MIT-LICENSE
 */
import { gql } from '@apollo/client'

export const B3_POST_BUNDLE_AUTHORIZATION = gql`
  mutation bundleAuthorization($input: UserAuthType!) {
    authorization(authData: $input) {
      result {
        token
        user {
          id
          firstName
          lastName
          email
          phone
          entityId: bcId
          role
          uuid
        }
      }
    }
  }
`
